import {RecordForm} from '../forms/RecordForm';


import {useAccount} from '../hooks/useAccount';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {
    FormPageLayout,
    SimplePageContentWrapper
} from "@flexinet/ui-components";
import {useNavigate} from "react-router-dom";


export const AddPage = () => {

    const navigate = useNavigate();

    const {
        record,
        createRecord,
    } = useAccount();

    return (
        <FormPageLayout
            title='Add Account'
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm record={record || {} as any} handleSubmit={createRecord} handleCancel={() => navigate('/accounts')}/>
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
